import { render, staticRenderFns } from "./BannerShopByBrandEdit.vue?vue&type=template&id=93437d6c&"
import script from "./BannerShopByBrandEdit.vue?vue&type=script&lang=js&"
export * from "./BannerShopByBrandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports